export const mapSelection = (selection) => {
    const [id, handicap] = selection.id.split('_');
    return ({
        selectionId: id,
        handicap: handicap && parseFloat(handicap.replace('-', '.')),
    });
};
